import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("Campo obrigatório")
    .email("Insira um e-mail em formato válido. Ex: exemplo@hotmail.com"),
  password: Yup.string().required("Campo obrigatório"),
});
